// extracted by mini-css-extract-plugin
module.exports = {"container":"share-module--container--BhT17","icon":"share-module--icon--1yB_V"};